export const useStyles = (color: string, size?: 'xs' | 'small' | 'medium' | 'big') => {
  let chosenSize = {
    status: {
      height: '8px',
      width: '26px',
    },
    text: {
      fontSize: '16px',
    },
  }

  switch (size) {
    case 'xs':
      chosenSize = {
        status: {
          height: '6px',
          width: '18px',
        },
        text: {
          fontSize: '12px',
        },
      }
      break
    case 'small':
      chosenSize = {
        status: {
          height: '6px',
          width: '18px',
        },
        text: {
          fontSize: '14px',
        },
      }
      break
    case 'big':
      chosenSize = {
        status: {
          height: '9px',
          width: '30px',
        },
        text: {
          fontSize: '18px',
        },
      }
      break
    default:
      break
  }

  return {
    chip: ({ fit }: { fit: boolean; }) => ({
      width: fit ? 'fit-content' : '90px',
      background: color,
      color: '#fff',
      fontSize: chosenSize.text,
      fontWeight: '500',
      ...(size == 'xs') && ({
        fontSize: '12px',
        height: '28px',
        paddinRight: '10px',
        paddinLeft: '10px',
      })
    }),
    containerStatus: {
      display: 'flex',
      alignItems: 'center',
      gap: 1,
    },
    status: (hide:boolean) => ({
      display: hide ? 'none':'block',
      height: chosenSize.status.height,
      width: chosenSize.status.width,
      background: color,
      borderRadius: '40px',
    }),
    statusText: {
      color: color,
      fontSize: chosenSize.text.fontSize,
    },
  }
}
